export const PATH_ROUTES = {
  // AUTH ROUTES
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  OTP_REGISTER: '/otp-register',
  SIGNUP: '/signup',
  SIGNUP_OTP: '/signup/otp',
  SIGNUP_VERIFICATION: '/signup/verification',
  HSBC_VERIFICATION: '/signup/hsbc-verification',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_PASSWORD_OTP: '/forgot-password/otp',

  // DASHBOARD ROUTES
  DASHBOARD: '/',
  FACE_SCAN: '/face-scans',
  START_FACE_SCAN: '/start-scan',
  FACE_SCAN_RESULT: '/start-scan/result',
  MOBILE_QR_SCAN: '/qr-face-scan',

  INTERPRET_LAB_REPORT: '/interpret-lab-report',
  GENERATE_LAB_REPORT: '/interpret-lab-report/generate',

  PERSONALISED_AI_REPORT: '/personalised-ai-report',
  GENERATE_AI_REPORT: '/personalised-ai-report/generate',

  VOICE_SCAN: '/voice-scans',
  START_VOICE_SCAN: '/start-voice-scan',
  VOICE_SCAN_DETAIL: '/voice-scans/:id',

  SYMPTOM_CHECKER: '/symptom-checker',
  GENERATE_SYMPTOM_CHECKER: '/symptom-checker/generate',
  GENERATE_SYMPTOM_REVIEW: '/symptom-checker/review',
  GENERATE_SYMPTOM_GENERATING: '/symptom-checker/generating',

  RISK_ANALYSIS: '/risk-analysis',
  RISK_ANALYSIS_SCAN: '/risk-analysis/scan',
  RISK_ANALYSIS_DETAIL: '/risk-analysis/details',
  RISK_ANALYSIS_QUESTIONNAIRE: '/risk-analysis/questionnaire',

  HELP_DESK: '/helpdesk-tickets',
  HELP_DESK_CREATE: '/helpdesk-tickets/create',
  HELP_DESK_DETAILS: '/helpdesk-tickets/:ticketId',

  PROFILE: '/profile',
  ADD_MEMBER: '/profile/new-member',

  SEND_FEEDBACK: '/send-feedback',

  COMMUNICATION_PREFERENCE: '/communication-preference',

  QUESTIONNAIRE: '/questionnaire',

  NOTIFICATION: '/notifications',
  NOTIFICATION_DETAIL: '/notifications/:category',
};
